// Figma: login-success-redirecting (node 18050:693) — full-page centered spinner shown
// while TokenVerification is redeeming the magic-link token. Replaces LC2's plain
// LoadingBox (bare MUI CircularProgress) for this specific screen.
import React from 'react';
import {Box, Stack, Typography} from '@mui/material';
import {tokens} from '../../../themes/ThemeCustomization';
import SpinnerIcon from './SpinnerIcon';
import pageSpinnerIcon from '../../../assets/auth/page-spinner-icon.svg';

const PageSpinner = ({label = 'Logging in...'}) => (
    <Box
        sx={{
            minHeight: '100vh',
            backgroundColor: tokens.color.neutral50,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }}
    >
        <Stack alignItems="center" spacing={1}>
            <SpinnerIcon src={pageSpinnerIcon} size={24} />
            <Typography variant="body2" fontWeight={500}>
                {label}
            </Typography>
        </Stack>
    </Box>
);

export default PageSpinner;
